import React from 'react';
import { useDispatch } from 'react-redux';
import dynamic from 'next/dynamic';
import { actions as modalActions } from '@gcloud-npm/next12.app-controller.reducers-sagas.modals-reducer';
import {
  CONTENT_POSITION,
  IN_SCENE_EFFECT,
  OPACITY_LAYOUT_COLORS,
  OUT_SCENE_EFFECT,
} from '@gcloud-npm/next12.components.modal';
import Icon, {
  ICON_KIND,
  ICON_COLOR,
} from '@gcloud-npm/next12.components.icon-n';
import CustomLink from '@gcloud-npm/next12.components.custom-link';
import TextInfo from '@gcloud-npm/next12.components.text-info-n';

const Video = dynamic(() => import('./Video'));

export const COMPONENT_NAME = 'Video';

const VideoBanner = (props) => {
  const { bucleVideo } = props;

  const dispatch = useDispatch();

  const taggingInfo = {
    componentVariation: 'all',
    componentName: COMPONENT_NAME,
    componentProduct: '',
  };

  const handleModal = () => {
    const MODAL_PROPS = {
      contentPosition: CONTENT_POSITION.CENTER_CENTER,
      opacityLayoutColor: OPACITY_LAYOUT_COLORS.BLACK05,
      inSceneEffect: IN_SCENE_EFFECT.FADE_IN_RIGHT,
      outSceneEffect: OUT_SCENE_EFFECT.FADE_OUT_RIGHT,
      closeByClickingOutside: true,
      scrollAllowed: true,
    };
    dispatch(
      modalActions.addModal({
        id: 'video',
        type: 'MODAL',
        Element2Show: Video,
        elementProps: props,
        modalProps: MODAL_PROPS,
      })
    );
  };

  return (
    <section className="VideoBanner">
      <CustomLink
        onClick={handleModal}
        taggingInfo={{
          ...taggingInfo,
          componentContent: 'play',
        }}
      >
        <div className="videoBackground">
          <video
            autoPlay
            loop
            muted
            data-wf-ignore="true"
            data-object-fit="cover"
          >
            <source src={bucleVideo} data-wf-ignore="true" />
          </video>
          <div className="videoBannerWrapper">
            <div className="playIconWrapper">
              <Icon
                kind={ICON_KIND.MEDIUM}
                backgroundColor={ICON_COLOR.TRANSPARENT}
                size={41}
                id="Play"
                color={ICON_COLOR.WHITE}
                tabletProps={{
                  size: 81,
                }}
              />
              <div className="text">
                <TextInfo {...props['TextInfo-1']} />
                <TextInfo {...props['TextInfo-2']} />
              </div>
            </div>
            <div className="title">
              <div className="text">
                <TextInfo {...props['TextInfo-3']} />
              </div>
              <div className="text">
                <TextInfo {...props['TextInfo-4']} />
              </div>
            </div>
          </div>
        </div>
      </CustomLink>
      <style jsx>
        {`
          .VideoBanner {
            max-width: 100vw;
            display: block;
            flex-direction: column;
            align-items: center;
            position: relative;
            margin-bottom: 1rem;
            height: 100%;
            background-color: var(--color-emp--blue);
            .videoBackground > video {
              position: absolute;
            }
            .videoBackground {
              .videoBannerWrapper {
                height: auto;
                min-width: 100vw;
                align-items: flex-start;
                justify-content: center;
                display: flex;
                flex-direction: column;
                background-color: transparent;
                cursor: pointer;
                padding: 1rem;
                .playIconWrapper {
                  margin-left: 45%;
                  margin-top: 20%;
                  z-index: 0;
                  .text {
                    display: none;
                  }
                }
                .title {
                  padding-top: 7rem;
                  .text {
                    margin-bottom: 0.5rem;
                  }
                }
              }
            }
          }
          @media screen and (min-width: 769px) {
            .VideoBanner {
              overflow: hidden;
              background-color: var(--color-emp--transparent);
              .VideoBanner > button {
                width: 100%;
              }
              .videoBackground > video {
                position: absolute;
                margin: auto;
                width: 100%;
                height: 100%;
                right: -100%;
                bottom: -100%;
                top: -100%;
                left: -100%;
                object-fit: cover;
                z-index: -100;
              }
              .videoBackground {
                height: 40rem;
                .videoBannerWrapper {
                  padding-left: 4.375rem;
                  height: auto;
                  min-height: 40rem;
                  position: absolute;
                  background-color: transparent;
                  .playIconWrapper {
                    position: static;
                    display: flex;
                    align-items: center;
                    margin-top: 0.5rem;
                    margin-left: 0.5rem;
                    .text {
                      display: block;
                      margin-left: 0.5rem;
                    }
                  }
                  .title {
                    padding-top: 0;
                  }
                }
              }
            }
          }
        `}
      </style>
    </section>
  );
};

export default VideoBanner;
